<template>
  <div v-click-outside="close" id="form-card" class="form-card form-read-more">
    <img :src="card">
    <div class="login-card">
      <div :dir="this.$lang === 'ar' ? 'rtl' : 'ltr'">
        <div :class="[this.$lang === 'ar' ? 'bold-ar' : 'bold-en','login-header mb-md-3 mb-1']">
          <span v-if="isActive === 0">{{$t('hotLine.activate')}}</span>
          <span v-else>{{$t('hotLine.deactivate')}}</span>
        </div>
        <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','login-desc']">
          <span v-if="isActive === 0">{{$t('hotLine.enter')}}</span>
          <span v-else>{{$t('hotLine.enter2')}}</span>
        </div>
        <div :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','login-desc']" style="font-size: 12px" v-if="$store.state.window >= 700">
          <span v-if="isActive === 0">{{$t('hotLine.note')}}</span>
          <span v-else>{{$t('hotLine.note2')}}</span>
        </div>
        <div class="login-content row">
          <div class="col-6">
            <input id="num" @input="valid(gsm)" v-model="gsm" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','number-field px-2']" :placeholder="$t('hotLine.num')" type="text" maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'');" :dir="this.$lang === 'ar' ? 'rtl' : 'ltr'">
            <div autofocus v-if="!valid(gsm) && clicked" :class="[this.$lang === 'ar' ? 'right-align regular-ar' : 'left-align regular-en', 'validation']">{{$t('validation')}}</div>
          </div>
          <div class="col-6">
            <input @input="valid(followGsm)" v-model="followGsm" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','number-field px-2']" :placeholder="$t('hotLine.follow')" type="text" maxlength="10" oninput="this.value=this.value.replace(/[^0-9]/g,'');" :dir="this.$lang === 'ar' ? 'rtl' : 'ltr'">
            <div autofocus v-if="!valid(followGsm) && clicked" :class="[this.$lang === 'ar' ? 'right-align regular-ar' : 'left-align regular-en', 'validation']">{{$t('validation')}}</div>
          </div>
          <div class="col-12">
            <input v-model="password" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','number-field px-2']" :placeholder="$t('hotLine.password')" type="password" :dir="this.$lang === 'ar' ? 'rtl' : 'ltr'">
            <div v-if="password === '' && clicked" :class="[this.$lang === 'ar' ? 'right-align regular-ar' : 'left-align regular-en', 'validation']">{{$t('hotLine.passwordReq')}}</div>
          </div>
          <div class="col-12">
            <input v-model="nationalId" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','number-field px-2']" :placeholder="$t('hotLine.national')" type="text" maxlength="11" oninput="this.value=this.value.replace(/[^0-9]/g,'');" :dir="this.$lang === 'ar' ? 'rtl' : 'ltr'">
            <div v-if="nationalId === '' && clicked" :class="[this.$lang === 'ar' ? 'right-align regular-ar' : 'left-align regular-en', 'validation']">{{$t('hotLine.nationalReq')}}</div>
          </div>
        </div>
      </div>
    </div>

      <div :class="[this.$lang === 'ar' ? 'black-blur-right' : 'black-blur-left' , 'black-blur']"></div>
    <div @click="submitHandle" :class="[this.$lang === 'ar' ? 'yellow-button-right' : 'yellow-button-left', 'yellow-button flex-center']">
      <div :class="[this.$lang === 'ar' ? 'white-blur-right' : 'white-blur-left','white-blur']"></div>
      <div v-if="isLoading" class="spinner-border text-light" role="status"></div>
<!--      <img v-if="!isLoading" class="inner_arrow" src="../../assets/icons/buttonArrow.svg">-->
      <span v-if="!isLoading" :class="[this.$lang === 'ar' ? 'regular-ar' : 'regular-en','read-more']">{{$t('submit')}}</span>
    </div>
    <div :class="[this.$lang === 'ar' ? 'blur-outer-button-right' : 'blur-outer-button-left' ,'blur-outer-button']">
    </div>
  </div>
</template>
<script>
import pcCard from '../../assets/images/form-card-shadow.svg'
import mobileCard from '../../assets/images/outer-card-form.svg'
import $ from 'jquery'
import ms from '../../utils/messeging.js'
import HotLineRepository from '../../repositories/HotLineRepository'
export default {
  props: {
    isActive: Number
  },
  data () {
    return {
      card: pcCard,
      gsm: '',
      followGsm: '',
      nationalId: '',
      password: '',
      isLoading: false,
      clicked: false,
      hotLineRepo: new HotLineRepository()
    }
  },
  created () {
    if (this.$store.state.window <= 700) {
      this.card = mobileCard
    }
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      if (val <= 700) {
        this.card = mobileCard
      } else {
        this.card = pcCard
      }
    })
  },
  mounted () {
    setTimeout(() => {
      if (this.$lang === 'ar') {
        $('.form-card img').css('transform', 'rotateY(180deg)')
      }
    })
  },
  methods: {
    valid (val) {
      const regex = /^[0][9][4567][0-9]{7}$/
      return regex.test(val)
    },
    close () {
      this.$store.state.activateHotLine = false
      this.$store.state.deactivateHotLine = false
    },
    async submitHandle () {
      this.clicked = true
      if (this.isLoading || !this.valid(this.gsm) || !this.valid(this.followGsm) || this.password === '' || this.nationalId === '') {
        return
      }
      this.isLoading = true
      const formData = new FormData()
      formData.append('gsm', this.gsm)
      formData.append('nationalId', this.nationalId)
      formData.append('followupGsm', this.followGsm)
      formData.append('gsmPassword', this.password)
      try {
        const method = this.isActive === 0 ? 'activate' : 'deactivate'
        const response = await this.hotLineRepo[method](formData)
        if (response.data.status === 200) {
          this.close()
          ms.successMessage(response.data.message)
        } else {
          ms.errorMessage(response.data.message)
        }
      } catch (e) {
        // this.isLoading = false
        try {
          if (e.response.data) {
            ms.errorMessage(e.response.data.message)
          }
        } catch (e) {
          ms.errorMessage('Sorry Something Went Wrong')
        }
      }
      this.isLoading = false
      document.activeElement.blur()
      setTimeout(() => {
        document.getElementById('first').focus()
      })
    }
  }
}
</script>
<style>
.col-6, .col-12 {
  padding: 8px !important;
}
.v-dialog.v-dialog--active{
  box-shadow: unset !important;
  margin: 0 ;
}
.v-dialog.dialog-bottom-transition-leave-active.dialog-bottom-transition-leave-to{
  box-shadow: none !important;
  outline: none !important;
}
.form-card{
  width: 650px;
  height: 450px;
  margin: 0 auto;
  position: relative;
}
.form-card img{
  width: 100%;
  height: 100%;
}
/*@media (max-width: 800px) {*/
/*  .form-card{*/
/*    width: 500px;*/
/*    height: 330px;*/
/*  }*/
/*}*/
@media screen and (max-width: 700px){
  .form-card{
    width: 395px;
    height: 415px;
  }
}
@media screen and (max-width: 400px){
  .form-card{
    width: 350px;
    height: 400px;
  }
}
</style>
<style lang="scss">
.form-read-more .read-more {
  display: inline-block!important;
  //animation: none!important;
}
#form-card {
  .yellow-button{
    width: 70px !important;
    height: 70px !important;
    bottom: 27px;
  }
  .blur-outer-button{
    width: 73px;
    height: 73px;
    bottom: 25.5px;
  }
  .black-blur{
    bottom: 23px;
  }
  .white-blur-left{
    left: -4px !important;
  }
  .white-blur-right{
    right: -4px !important;
  }
  .yellow-button-left{
    right: 87.5px !important;  /*128.5*/
  }
  .blur-outer-button-left{
    right: 86px !important; /*128.5*/
  }
  .black-blur-left{
    right: 84.5px !important;
  }
  .yellow-button-right{
    right: 493.5px !important;
  }
  .blur-outer-button-right{
    right: 492.8px !important;
  }
  .black-blur-right{
    right: 487.5px !important;
  }
  .outer-img-ar{
    transform: rotateY(180deg) !important;
  }
}
//@media (max-width: 800px) {
//  #form-card{
//    .yellow-button{
//      width: 60px !important;
//      height: 60px !important;
//      bottom: 20px !important;
//    }
//    .blur-outer-button{
//      width: 63px;
//      height: 63px;
//      bottom: 19px !important;
//    }
//    .white-blur{
//      top: -4px !important;
//    }
//    .black-blur{
//      width: 40px;
//      height: 40px;
//      bottom: 22px;
//    }
//    .yellow-button-left{
//      right: 71.5px !important;
//    }
//    .blur-outer-button-left{
//      right: 70.5px !important;
//    }
//    .black-blur-left{
//      right: 70.5px !important;
//    }
//    .yellow-button-right{
//      right: 368.5px !important;
//    }
//    .blur-outer-button-right{
//      right: 366.5px !important;
//    }
//    .black-blur-right{
//      right: 386.5px !important;
//    }
//  }
//}
@media (max-width: 700px) {
  #form-card{
    .yellow-button{
      width: 80px !important;
      height: 80px !important;
      bottom: 22px !important;
    }
    .blur-outer-button{
      width: 83px !important;
      height: 83px !important;
      bottom: 20px !important;
    }
    .white-blur{
      top: -4px !important;
    }
    .black-blur{
      bottom: 28px !important;
    }
    .yellow-button-left{
      right: 106px !important;
    }
    .blur-outer-button-left{
      right: 105.5px !important;
    }
    .black-blur-left{
      right: 102.5px !important;
    }
    .yellow-button-right{
      right: 209.5px !important;
    }
    .blur-outer-button-right{
      right: 208px !important;
    }
    .black-blur-right{
      right: 222.5px !important;
    }
  }
}
@media (max-width: 400px) {
  #form-card {
    .yellow-button{
      width: 72px !important;
      height: 72px !important;
      bottom: 23.5px !important;
    }
    .blur-outer-button{
      width: 75px !important;
      height: 75px !important;
      bottom: 21.5px !important;
    }
    .white-blur{
      top: -4px !important;
    }
    .black-blur{
      bottom: 22px;
    }
    .yellow-button-left{
      right: 89.5px !important;
    }
    .blur-outer-button-left{
      right: 88.5px !important;
    }
    .black-blur-left{
      right: 85.5px !important;
    }
    .yellow-button-right{
      right: 188.5px !important;
    }
    .blur-outer-button-right{
      right: 186.5px !important;
    }
    .black-blur-right{
      right: 206.5px !important;
    }
  }
}
</style>
<style lang="scss">
@import "src/assets/sass/main";
.validation{
  font-size: 11px;
  color: $--red !important;
  width: 100%;
  margin: 0 auto;
}
.v-stepper.v-stepper--is-booted.v-sheet.theme--light,
.v-stepper.v-sheet.theme--light{
  height: 100%;
  box-shadow: none !important;
  background: transparent !important;
}
.v-stepper__items,
.v-stepper__wrapper{
  height: 100%;
}
.v-stepper__header{
  display: none;
}
.v-stepper__content{
  padding: 0 !important;
}
button.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default.primary,
button.v-btn.v-btn--text.theme--light.v-size--default{
  display: none;
}
.v-overlay.theme--dark{
  display: none !important;
}
.login-card {
  width: 500px;
  height: 320px;
  position: absolute;
  top: 25px;
  left: 77px;
}
.login-header{
  padding: 1.5rem 0 0 0;
  color: $--yellow;
  font-size: 20px;
}
.login-desc{
  font-size: 14px;
}
.login-content{
  padding-top: 0.5rem;
}
.verify-content{
  padding-top: 2.8rem;
}
.verify-footer{
  padding: 2.8rem 0 1.5rem 0;
}
.number-field{
  border: 2px solid $--yellow;
  width: 100%;
  line-height: 2.2;
  border-radius: 14px;
  height: 40px;
}
//.number-field:focus{
//  outline: none;
//}
.number-field::placeholder{
  color: #000;
  font-size: 12px;
}
.login-footer{
  padding: 3.5rem 0 20px 0;
  font-size: 12px;
  span {
    color: $--yellow !important;
    cursor: pointer;
  }
}
.verify-footer{
  font-size: 12px;
  span {
    color: $--yellow;
    //cursor: pointer;
  }
}
.btn-container{
  width: 20px;
  height: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stepper-btn {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #bcbbbb;
  cursor: pointer;
}
.active-step{
  background: #383838 !important;
}
input.verify-field {
  width: 50px;
  height: 50px;
  border: 2px solid #FFCB05;
  border-radius: 9px;
  margin: 0 5px;
  text-align: center;
}
//.verify-field:focus{
//  outline: none;
//}
//@media (max-width: 800px) {
//  .login-card {
//    width: 390px;
//    height: 230px;
//    left: 55px;
//  }
//  .login-header{
//    padding: 0;
//  }
//  .login-content{
//    padding-top: 0.5rem;
//  }
//  .number-field{
//    //width: 85%;
//  }
//  .login-footer{
//    padding: 30px 0 20px 0;
//  }
//  .verify-content{
//    padding-top: 1.5rem;
//  }
//  .verify-footer{
//    padding: 1.5rem 0 1.5rem 0;
//  }
//  .login-desc {
//    font-size: 13px!important;
//  }
//}
@media screen and (max-width: 700px){
  .login-card {
    width: 280px;
    height: 290px;
    left: 57px;
  }
  .login-header{
    padding: 10px 0 0 0;
    font-size: 18px;
  }
  .login-desc{
    font-size: 11px;
  }
  .login-content{
    padding: 0.5rem 15px 0 15px;
  }
  .number-field{
    //width: 100%;
    //line-height: 2.5;
  }
  .login-footer{
    padding-top: 4rem;
    font-size: 11px;
  }
  input.verify-field {
    margin: 0 3px;
    width: 38px;
    height: 38px;
    border-radius: 8px;
  }
  .verify-content{
    padding-top: 3.5rem;
  }
  .verify-footer{
    padding: 3.5rem 0 1.5rem 0;
  }
}
@media screen and (max-width: 400px){
  .login-content{
    padding: 1rem 8px 0 8px;
  }
  .login-card {
    width: 270px;
    height: 290px;
    left: 38px;
  }
  .login-header{
    padding: 0;
    font-size: 18px;
  }
  .login-desc{
    font-size: 13px;
  }
  .login-content{
    padding-top: 0rem;
  }
  .number-field{
    //width: 100%;
    //line-height: 3;
  }
  .login-footer{
    padding-top: 2.5rem;
    font-size: 14px;
  }
}
</style>
